import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import panZoom from '../../modifiers/pan-zoom';

interface ImageViewerSignature {
  Args: {
    imageUrl: string;
    altText: string;
  };
  Element: HTMLDivElement;
}

export default class ImageViewer extends Component<ImageViewerSignature> {
  @tracked isLoaded = false;

  @action
  handleLoad(): void {
    this.isLoaded = true;
  }

  @action
  handleError(): void {
    this.isLoaded = true;
  }

  <template>
    <div class="flex h-full w-full items-center justify-center">
      {{#unless this.isLoaded}}
        <div
          class="loading loading-spinner loading-lg text-primary"
          aria-hidden="true"
        ></div>
      {{/unless}}

      <img
        src={{@imageUrl}}
        alt={{@altText}}
        {{panZoom}}
        {{on "load" this.handleLoad}}
        {{on "error" this.handleError}}
        class="max-h-full max-w-full cursor-grab touch-none transition-opacity duration-300 select-none
          {{unless this.isLoaded 'opacity-0'}}"
      />
    </div>
  </template>
}
